/* eslint-disable eqeqeq */
import React, { useLayoutEffect, useRef, useState } from "react";
import { TableBody, Button, TableContainer, Table, TableHead, TableRow, TableCell, TextField, Tab, Tabs, ButtonGroup, Tooltip, Box } from "@mui/material";
import { useSelector } from "react-redux";

import { useHistory, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import moment from "moment";
/** Const */
import { statusColor } from "../../config";

/** Components */
// import { DeleteDialog } from "../../commons/dialog.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import FuelTicketPreview from "../commons/fuelTicketPreview.component";
import FileInput from "../../commons/FileInput.component";

/** Icons */
import PrintIcon from "@mui/icons-material/Print";
// import DeleteIcon from "@mui/icons-material/Delete";
import RepeatOneIcon from "@mui/icons-material/RepeatOne";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddTaskIcon from "@mui/icons-material/AddTask";

/** Api */
import {
  approveInvoice,
  // deleteInvoice,
  getAcsreg,
  getAircraft,
  getCtmdocs,
  getFlight,
  getInvoiceById,
  getInvoicePDF,
  getInvoiceZip,
} from "../../../services/api";

/** Hook */
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

const cols = ["Hàng hoá", "Số lượng", "Đơn vị tính", "Nhiệt độ", "Tỷ trọng", "d15", "lit", "vcf", "wcf", "l15", "kg"];

export default function InvoiceDetail({ data = "", invoiceid, onUpdate }) {
  //type = 0 thi khong hien pdf ma hien detail
  // boiler plate
  const [t] = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  // state
  const [dataState, setData] = useState(data);
  const [tab, setTab] = useState(location.state?.tab || 0);
  const [pdf, setPDF] = useState("loading");
  const [isViewPrevFt, setIsViewPrevFt] = useState(false);
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const isTruck = dataState?.loadingtype_id === 3 && dataState?.saletype_id === 3;
  const isShip = dataState?.loadingtype_id === 5 && dataState?.saletype_id === 1;
  const customer_name = dataState?.customer_name + (dataState?.shipped_to ? ` / ${dataState?.shipped_to == 462921 ? dataState?.adhoc_shippedto : dataState?.airline_name}` : "");
  // method
  const handleApprove = (res) => {
    if (res.code === 200) {
      setData(res.data);
      onUpdate?.(res, res.data);
    }
  };
  // const handleDeleteAction = () => {
  //   return deleteInvoice(dataState.id);
  // };
  // const handleDeleteResponse = (res) => {
  //   if (res.code === 200) {
  //     setData((prev) => ({ ...prev, status: "DELETED" }));
  //     onUpdate?.(res, { ...dataState, status: "DELETED" });
  //   }
  // };

  const handleDownloadZip = () => {
    getInvoiceZip(dataState.id).then((res) => {
      if (res.code !== 200) {
        enqueueSnackbar(res.message);
        return;
      }
      const a = document.createElement("a");
      a.href = process.env.REACT_APP_URL_PDF + res.data;
      a.download = dataState.fkey + ".zip";
      a.click();
    });
  };
  useLayoutEffect(() => {
    setData(null);
    if (!invoiceid) return;
    getInvoiceById(invoiceid).then((res) => {
      if (res.code === 200) setData(res.data);
      else history.replace(`/invoices/${location.search}`);
    });
    getInvoicePDF(invoiceid).then((res) => {
      if (res.code === 200) {
        setPDF(res.data);
      } else setPDF(null);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceid]);

  if (dataState)
    return (
      <div>
        <div style={{ marginBottom: 20, backgroundColor: "#b3deff", position: "relative", height: 50 }}>
          <Box display="flex">
            <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
              <Tab value={0} label="Thông tin hóa đơn" />
              <Tab value={1} label="Xem hoá đơn dạng pdf" />
            </Tabs>
          </Box>
          <ButtonGroup style={{ height: 50, position: "absolute", top: 0, right: 0 }}>
            {!isViewPrevFt && (
              <Button variant="outlined" color="primary" onClick={() => handlePrint()}>
                <Tooltip title="In phiếu giao nhận">
                  <PrintIcon />
                </Tooltip>
              </Button>
            )}
            {!isViewPrevFt && (
              <Button variant="outlined" color="primary" onClick={() => handleDownloadZip()}>
                <Tooltip title="Tải file hoá đơn">
                  <AttachFileIcon />
                </Tooltip>
              </Button>
            )}
            {["PUBLISHED", "APPROVED", "ADJUSTED"].includes(dataState?.status) && dataState.component !== "INV_FT" && (
              <Button variant="outlined" color="primary" onClick={() => history.push({ pathname: `/invoices/adj/${dataState.id}`, state: dataState })}>
                <Tooltip title="Phát hành hoá đơn điều chỉnh">
                  <AddTaskIcon />
                </Tooltip>
              </Button>
            )}
            {dataState.status !== "DELETED" && dataState.component !== "INV_FT" && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() =>
                  history.push({ pathname: `/invoices/edit/${dataState.loadingtype_id == 1 ? "airinv" : dataState.loadingtype_id == 5 ? "ship" : "truck"}/${dataState.id}`, state: dataState })
                }
              >
                <Tooltip title="Phát hành hoá đơn thay thế">
                  <RepeatOneIcon />
                </Tooltip>
              </Button>
            )}
            {/* {dataState.status !== "DELETED" && (
              <ButtonWithAPICall variant="outlined" api={handleDeleteAction} dialogNode={(params) => <DeleteDialog {...params} />} response={handleDeleteResponse}>
                <Tooltip title="Huỷ hoá đơn">
                  <DeleteIcon />
                </Tooltip>
              </ButtonWithAPICall>
            )} */}
          </ButtonGroup>
        </div>

        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "calc(100% - 320px)", marginRight: "auto" }}>
            <div hidden={tab !== 0}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <h2 style={{ marginBottom: 0 }}>THÔNG TIN HÓA ĐƠN SỐ: {dataState.code}</h2>
                <div className={`status ${dataState?.status}`} style={{ color: statusColor[dataState?.status] }}>
                  {t(dataState?.status)}
                </div>
                {dataState.parent_id && (
                  <span className={`status ${dataState.status}`} style={{ color: statusColor[dataState.status] }}>
                    Hoá đơn gốc:{" "}
                    <span onClick={() => history.push(`/invoices/${dataState.parent_id}${location.search}`)} style={{ cursor: "pointer", textDecoration: "underline" }}>
                      {dataState.parent_code}
                    </span>
                  </span>
                )}
              </div>
              <div align="left" style={{ marginBottom: 0 }}>
                <b>{t("Thông tin cơ bản")}</b>:
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        Mẫu số: {dataState.form_no} - {dataState.serial}
                      </TableCell>
                      <TableCell align="left">Số hóa đơn: {dataState.code}</TableCell>
                      <TableCell align="left">
                        ERP Code: {dataState.erp_id} - {dataState.erp_code}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Ngày phát hành: {dataState.valid_date && moment(dataState.valid_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell align="left">Giờ bắt đầu: {dataState.start_pump && moment(dataState.start_pump).format("HH:mm")}</TableCell>
                      <TableCell align="left">Giờ kết thúc: {dataState.end_pump && moment(dataState.end_pump).format("HH:mm")}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Khách hàng: {customer_name}</TableCell>
                      <TableCell align="left" colSpan={1}>
                        Mã số thuế: {dataState.customer_tax}
                      </TableCell>
                      <TableCell align="left" colSpan={1}>
                        Mã tra cứu: {dataState.fkey}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" colSpan={3}>
                        Địa chỉ: {dataState.customer_address}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" colSpan={1}>
                        Xuất bán từ kho: {dataState.inventory_name}
                      </TableCell>
                      <TableCell align="left" colSpan={2}>
                        Chứng chỉ số: {dataState.invoiceproducts[0]?.cert_no}
                      </TableCell>
                    </TableRow>
                    {!isTruck && (
                      <>
                        <TableRow>
                          <TableCell align="left">Số chuyến bay: {dataState.flight_no}</TableCell>
                          <TableCell align="left" colSpan={2}>
                            Tuyến bay: {dataState.route}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="left">Loại máy bay: {dataState.aircraft_code}</TableCell>
                          <TableCell align="left" colSpan={2}>
                            A/C Reg: {dataState.code_aircraft}
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div align="left" style={{ margin: "10px 0 10px" }}>
                <b>{t("Thông tin hàng hóa")}:</b>
              </div>
              <TableContainer style={{ marginBottom: 20 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {cols.map((item, index) => (
                        <TableCell key={index} align="center" style={{ textTransform: "capitalize" }}>
                          {item}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataState.invoiceproducts?.length ? (
                      dataState.invoiceproducts?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{item.product_name}</TableCell>
                          <TableCell align="center">{Math.round(item.quantity)?.toLocaleString()}</TableCell>
                          <TableCell align="center">{item.product_unit}</TableCell>
                          <TableCell align="center">{item.temp && parseFloat(item.temp)?.toFixed(2)}</TableCell>
                          <TableCell align="center">{item.density && parseFloat(item.density)?.toFixed(4)}</TableCell>
                          <TableCell align="center">{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                          <TableCell align="center">{Math.round(item.lit)?.toLocaleString()}</TableCell>
                          <TableCell align="center">{item.vcf && parseFloat(item.vcf)?.toFixed(4)}</TableCell>
                          <TableCell align="center">{item.wcf && parseFloat(item.wcf)?.toFixed(4)}</TableCell>
                          <TableCell align="center">{Math.round(item.l15)?.toLocaleString()}</TableCell>
                          <TableCell align="center">{Math.round(item.kg)?.toLocaleString()}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={20}>{t("Không có dữ liệu")}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {dataState.status !== "FAIL" &&
                dataState.status !== "DELETED" &&
                (isTruck ? (
                  <TruckApproveForm onApprove={handleApprove} data={dataState} />
                ) : isShip ? (
                  <ShipApproveForm onApprove={handleApprove} data={dataState} />
                ) : (
                  <AirApproveForm onApprove={handleApprove} data={dataState} />
                ))}
            </div>
            <div hidden={tab === 0}>{pdf && pdf !== "loading" ? <iframe title="pdf" width="100%" style={{ height: "calc(100vh - 185px)" }} src={pdf} /> : <div>Không có File PDF</div>}</div>

            {/* <Button style={{margin: '20px 0'}} variant='contained' onClick={handleSubmit} disabled={isSaving || !selectedFlight || !selectedAircraft || selectedFlight.flight_no === dataState.flight_no && dataState.aircraft === selectedAircraft.name && dataState.code_aircraft === codeAircraftField}>Save</Button> */}
          </div>
          <div style={{ width: "300px", height: 700 }}>
            {isViewPrevFt ? (
              <img alt="" src={dataState.pre_ft} width="100%" style={{ objectFit: "contain", height: 633 }} />
            ) : (
              <FuelTicketPreview
                printRef={printRef}
                type="invoice"
                data={{
                  ...dataState,
                  customer_name,
                  refueler_no: dataState.invoiceproducts[0]?.refueler_no,
                  product_name: dataState.invoiceproducts[0]?.product_name,
                  hydrant_sys: dataState.invoiceproducts[0]?.hydrant_sys,
                  inventory_name: dataState.inventory_name,
                  cert_no: dataState.invoiceproducts[0]?.cert_no,
                  density: dataState.invoiceproducts[0]?.density,
                  l15: dataState.loadingtype_id === 3 ? dataState.invoiceproducts[0]?.quantity : dataState.invoiceproducts[0]?.l15,
                  temp: dataState.invoiceproducts[0]?.temp,
                  meter_before_pump: dataState.invoiceproducts[0]?.meter_before_pump,
                  meter_after_pump: dataState.invoiceproducts[0]?.meter_after_pump,
                  vehicle: dataState.invoiceproducts[0]?.refueler_license_plate || dataState.invoiceproducts[0]?.refueler_no,
                }}
              />
            )}
            {dataState.pre_ft && (
              <Button style={{ marginTop: 10 }} variant="contained" color="success" onClick={() => setIsViewPrevFt((prev) => !prev)}>
                Xem FT {!isViewPrevFt ? "cũ" : "mới"}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  else return "";
}
const AirApproveForm = ({ onApprove, data }) => {
  // hook
  const user = useSelector((state) => state.user.data);
  const [t] = useTranslation();
  const [input, setInput] = useState({
    saletype: null,
    flight: null,
    aircraft: null,
    saleorder: null,
    ctmdocs: null,
    acsreg: null,
    note: data.note || "",
    image: "",
  });
  const api = async () => {
    const object = {
      flight_id: input.flight?.id,
      flight_no: input.flight?.flight_no,
      aircraft_id: input.aircraft?.id,
      customdoc_id: input.ctmdocs?.id,
      acsreg_id: input.acsreg?.id,
      note: input.note,
      component: data.component,
    };
    const promise =
      input.image &&
      new Promise((res, rej) => {
        const fr = new FileReader();
        fr.readAsDataURL(input.image);
        fr.onload = () => {
          object.pre_ft = fr.result;
          res();
        };
      });
    if (input.image) await promise;
    return approveInvoice(data.id, object);
  };
  return (
    <div align="left">
      <div style={{ margin: "10px 0 10px" }}>
        <b>{t("Thông tin duyệt hóa đơn")}:</b>
      </div>
      <FilterBy
        label={t("Số chuyến bay")}
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        getDataFunc={() => getFlight({ status: 1, organization_id: user?.organization_id })}
        setDefaultFunc={(option) => setInput((prev) => ({ ...prev, flight: option.find((item) => item.id === data.flight_id) }))}
        triggerSetDefaultFunc={true}
        triggerGetDataFunc={Boolean(user)}
        value={input.flight}
        getOptionLabel={(option) => `${option.flight_no} ${option.route}` || ""}
        onChange={(e, newValue) => setInput((prev) => ({ ...prev, flight: newValue }))}
      />
      {data.component === "S11" && (
        <FilterBy
          label={t("Tờ khai hải quan")}
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          getDataFunc={() => getCtmdocs({ status: 1, organization_id: user?.organization_id, valid_date: moment(data.valid_date).format("YYYY-MM-DD"), quantity: data.invoiceproducts?.[0]?.kg })}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, ctmdocs: option.find((item) => item.id === data.customdoc_id) }))}
          triggerSetDefaultFunc={true}
          triggerGetDataFunc={Boolean(user)}
          value={input.ctmdocs}
          getOptionLabel={(option) => `${option.id} - ${option.tntxNo}` || ""}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, ctmdocs: newValue }))}
        />
      )}
      <FilterBy
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        label="Đăng bạ tàu bay"
        fullWidth
        getDataFunc={() => getAcsreg({ status: 1, customer_id: data.customer_id })}
        getDataDependencies={[input.customer]}
        setDefaultFunc={(option) => setInput((prev) => ({ ...prev, acsreg: option.find((item) => item.id === data.acsreg_id) }))}
        triggerSetDefaultFunc={true}
        value={input.acsreg}
        onChange={(e, newValue) => setInput((prev) => ({ ...prev, acsreg: newValue }))}
        getOptionLabel={(option) => `${option.id} - ${option.code}`}
      />
      <FilterBy
        label={t("Chủng máy bay")}
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        setDefaultFunc={(option) => setInput((prev) => ({ ...prev, aircraft: option.find((item) => item.id === data.aircraft_id) }))}
        triggerSetDefaultFunc={true}
        getDataFunc={() => getAircraft({ status: 1 })}
        value={input.aircraft}
        onChange={(e, newValue) => setInput((prev) => ({ ...prev, aircraft: newValue }))}
      />
      <FileInput
        label={t("FT gốc")}
        accept="image/*"
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        value={input.image}
        onChange={(file) => setInput((prev) => ({ ...prev, image: file }))}
      />
      <TextField
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        InputLabelProps={{ shrink: true }}
        label={t("Ghi chú")}
        value={input.note}
        onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))}
      />

      <div style={{ margin: 10 }}>
        <ButtonWithAPICall variant="contained" api={api} response={onApprove}>
          {t("Duyệt")}
        </ButtonWithAPICall>
      </div>
    </div>
  );
};
const TruckApproveForm = ({ onApprove, data }) => {
  // hook
  const [t] = useTranslation();
  const [input, setInput] = useState({
    note: data.note || "",
    image: "",
  });
  const api = async () => {
    const object = {
      note: input.note,
      component: data.component,
    };
    const promise =
      input.image &&
      new Promise((res, rej) => {
        const fr = new FileReader();
        fr.readAsDataURL(input.image);
        fr.onload = () => {
          object.pre_ft = fr.result;
          res();
        };
      });
    if (input.image) await promise;
    return approveInvoice(data.id, object);
  };
  return (
    <div>
      <div align="left" style={{ margin: "10px 0 10px" }}>
        <b>{t("Thông tin duyệt hóa đơn")}:</b>
      </div>
      <FileInput
        label={t("Ảnh")}
        accept="image/*"
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        value={input.image}
        onChange={(file) => setInput((prev) => ({ ...prev, image: file }))}
      />
      <TextField label={t("Ghi chú")} value={input.note} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} style={{ display: "inline-flex", width: 240, margin: "5px 10px" }} />
      <div style={{ margin: 10 }}>
        <ButtonWithAPICall variant="contained" api={api} response={onApprove}>
          {t("Duyệt")}
        </ButtonWithAPICall>
      </div>
    </div>
  );
};
const ShipApproveForm = ({ onApprove, data }) => {
  // hook
  const user = useSelector((state) => state.user.data);
  const [t] = useTranslation();
  const [input, setInput] = useState({
    ctmdocs: null,
    note: data.note || "",
    image: "",
  });
  const api = async () => {
    const object = {
      customdoc_id: input.ctmdocs?.id,
      note: input.note,
      component: data.component,
    };
    const promise =
      input.image &&
      new Promise((res, rej) => {
        const fr = new FileReader();
        fr.readAsDataURL(input.image);
        fr.onload = () => {
          object.pre_ft = fr.result;
          res();
        };
      });
    if (input.image) await promise;
    return approveInvoice(data.id, object);
  };
  return (
    <div>
      <div align="left" style={{ margin: "10px 0 10px" }}>
        <b>{t("Thông tin duyệt hóa đơn")}:</b>
      </div>
      <FilterBy
        label={t("Tờ khai hải quan")}
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        getDataFunc={() => getCtmdocs({ status: 1, organization_id: user?.organization_id, valid_date: moment(data.valid_date).format("YYYY-MM-DD"), quantity: data.invoiceproducts?.[0]?.kg })}
        setDefaultFunc={(option) => setInput((prev) => ({ ...prev, ctmdocs: option.find((item) => item.id === data.customdoc_id) }))}
        triggerSetDefaultFunc={true}
        triggerGetDataFunc={Boolean(user)}
        value={input.ctmdocs}
        getOptionLabel={(option) => `${option.id} - ${option.tntxNo}` || ""}
        onChange={(e, newValue) => setInput((prev) => ({ ...prev, ctmdocs: newValue }))}
      />
      <FileInput
        label={t("Ảnh")}
        accept="image/*"
        style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
        value={input.image}
        onChange={(file) => setInput((prev) => ({ ...prev, image: file }))}
      />
      <TextField style={{ display: "inline-flex", width: 240, margin: "5px 10px" }} label={t("Ghi chú")} value={input.note} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />

      <div style={{ margin: 10 }}>
        <ButtonWithAPICall variant="contained" api={api} response={onApprove}>
          {t("Duyệt")}
        </ButtonWithAPICall>
      </div>
    </div>
  );
};
